"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.elementContainsAttribute = void 0;
var dom_utilities_1 = require("@fluentui/dom-utilities");
Object.defineProperty(exports, "elementContainsAttribute", { enumerable: true, get: function () { return dom_utilities_1.elementContainsAttribute; } });
//# sourceMappingURL=elementContainsAttribute.js.map